export default __webpack_public_path__ + "static/media/Wassily_Kandinsky_Launelinie_50_x_70_cm.c646a475.jpg";